<template>
  <div class="tt">
    <!-- Navegação de páginas -->
    <div
      v-if="listAvailableDays && Object.keys(listAvailableDays).length"
      class="tt-nav"
    >
      <button
        type="button"
        class="tt-nav-btn"
        :disabled="currentPage === 0"
        aria-label="Dias anteriores"
        @click="moreDays('prev')"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M15 18l-6-6 6-6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <!-- Grid de dias (até 4 por página) -->
      <div class="tt-days">
        <div v-for="(day, index) in pagination" :key="index" class="tt-day">
          <div class="tt-day-head">
            <span class="tt-day-week">{{ theWeekDay(day.slot_date) }}</span>
            <span class="tt-day-date num">{{ theDate(day.slot_date) }}</span>
          </div>
          <div class="tt-slots">
            <button
              v-for="(slot, idx) in day.slots"
              :key="idx"
              type="button"
              class="tt-slot"
              @click="schedule(slot.hour, slot.slot_date, slot.slot_id)"
            >
              {{ slot.hour }}
            </button>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="tt-nav-btn"
        :disabled="currentPage >= getMaxPage"
        aria-label="Próximos dias"
        @click="moreDays('next')"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M9 18l6-6-6-6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Estado vazio -->
    <div v-else class="tt-empty">
      <div class="tt-empty-ill">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <rect
            x="3"
            y="4"
            width="18"
            height="18"
            rx="2"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M16 2v4M8 2v4M3 10h18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <p class="tt-empty-text">Nenhum horário disponível no momento</p>
    </div>

    <!-- Toggle ver mais -->
    <div v-if="pagination.length" class="tt-footer">
      <button type="button" class="tt-more" @click="showMore = !showMore">
        {{ !showMore ? "Exibir mais horários" : "Exibir menos" }}
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            :d="showMore ? 'M18 15l-6-6-6 6' : 'M6 9l6 6 6-6'"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import {
  userMethods,
  userComputed,
  authComputed,
  doctorMethods,
  appointmentsMethods
} from "./../state/helpers";
import { formatDate, formatWeekDay } from "../utils/masks/formatSlotDate";

export default {
  name: "TimeTable",
  props: { doctor: { type: Object, default: null } },
  data() {
    return {
      currentPage: 0,
      showMore: false,
      availables: []
    };
  },

  mounted() {
    this.fetchDoctorsAvailables({ id: this.doctor.id }).then(response => {
      this.availables = response.data.filter(available => available.id);
    });
  },

  methods: {
    ...userMethods,
    ...doctorMethods,
    ...appointmentsMethods,
    moreDays(action) {
      if (action === "prev" && this.currentPage > 0) {
        return this.currentPage--;
      }
      if (action === "next" && this.currentPage < this.getMaxPage) {
        return this.currentPage++;
      }
    },
    loginOrCreate(urlName) {
      this.$router.push({ name: urlName });
    },
    schedule(hour, date, id) {
      // Modo seleção (reagendamento): devolve o horário ao pai em vez de
      // iniciar um agendamento novo.
      if (this.$listeners.select) {
        return this.$emit("select", { slot_id: id, slot_date: date, hour });
      }
      this.holdScheduleAppointment({
        scheduled_at: `${date} ${hour}:00`,
        scheduled_until: `${date} 00:00:00`,
        doctor: this.doctor,
        slot_date: date,
        slot_hour: hour,
        slot_id: id
      });
      if (this.loggedIn) {
        this.$router.push({ name: "Schedule" });
      } else {
        this.$bvModal.show("loginOrRegistration");
      }
    },

    verifyAuth() {
      if (!this.currentUser) return this.$router.push({ name: "Login" });
    },
    doctorHasAvailability(page) {
      return this.availables && this.availables[page];
    },
    listAvailableHours(availableHours) {
      return !this.showMore ? availableHours.slice(0, 4) : availableHours;
    },

    theWeekDay(value) {
      return formatWeekDay(value);
    },

    theDate(value) {
      return formatDate(value);
    }
  },

  computed: {
    ...authComputed,
    ...userComputed,
    isDetailsPage() {
      if (this.$route.name != "Site")
        return `background-color: #fff;
                padding: 2em;
                box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
                border-radius: 8px;
                position: sticky;
                top: 20px;`;

      return "";
    },
    listAvailableDays() {
      let reduced = this.availables.reduce((prevValue, currentValue) => {
        prevValue[currentValue.slot_date] = [
          ...(prevValue[currentValue.slot_date] || []),
          ...currentValue.slots.map(slot => ({
            slot_id: currentValue.id,
            slot_date: currentValue.slot_date,
            hour: slot
          }))
        ];
        return prevValue;
      }, {});
      return reduced;
    },
    pagination() {
      let pages = [];
      let reduced = this.listAvailableDays;
      Object.keys(reduced)
        .slice(this.currentPage * 4, this.currentPage * 4 + 4)
        .filter(day => {
          if (reduced[day]) {
            pages.push({
              slots: this.listAvailableHours(reduced[day]),
              slot_date: day
            });
          }
        });
      return pages;
    },
    getMaxPage() {
      return Math.ceil(Object.keys(this.listAvailableDays).length / 4) - 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.tt {
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
}

// Navegação: setas + grid de dias
.tt-nav {
  display: grid;
  grid-template-columns: 32px 1fr 32px;
  gap: var(--space-2, 8px);
  align-items: start;
}

.tt-nav-btn {
  width: 32px;
  height: 32px;
  border: 1.5px solid var(--color-gray-200, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: #fff;
  color: var(--color-gray-600, #475569);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
  flex: none;
  margin-top: 4px;
  padding: 0;

  &:hover:not(:disabled) {
    border-color: var(--color-primary, #1a6cf7);
    color: var(--color-primary, #1a6cf7);
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
}

// Grid de colunas por dia
.tt-days {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-2, 8px);

  @media (max-width: 560px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.tt-day-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--space-2, 8px) var(--space-1, 4px);
  margin-bottom: var(--space-2, 8px);
  border-bottom: 2px solid var(--color-gray-100, #f1f5f9);
}

.tt-day-week {
  font-size: 10px;
  font-weight: var(--fw-bold, 700);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-gray-400, #94a3b8);
}

.tt-day-date {
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--fw-bold, 700);
  color: var(--color-gray-800, #1e293b);
  margin-top: 2px;
}

.tt-slots {
  display: flex;
  flex-direction: column;
  gap: var(--space-1, 4px);
}

.tt-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 34px;
  border: 1.5px solid var(--color-gray-200, #e2e8f0);
  border-radius: var(--radius-sm, 6px);
  background: var(--color-gray-50, #f8fafc);
  font-family: var(--font-num, "Inter", sans-serif);
  font-size: var(--font-size-xs, 0.75rem);
  font-weight: var(--fw-semibold, 600);
  color: var(--color-gray-700, #334155);
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s, color 0.12s;

  &:hover {
    border-color: var(--color-accent, #d81a67);
    background: var(--color-accent-light, #fff0f7);
    color: var(--color-accent, #d81a67);
  }
}

// Estado vazio
.tt-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-8, 32px) var(--space-4, 16px);
  text-align: center;
}

.tt-empty-ill {
  width: 52px;
  height: 52px;
  border-radius: var(--radius-lg, 12px);
  background: var(--color-gray-100, #f1f5f9);
  color: var(--color-gray-400, #94a3b8);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--space-3, 12px);
}

.tt-empty-text {
  font-size: var(--font-size-sm, 0.875rem);
  color: var(--color-gray-500, #64748b);
  margin: 0;
}

// Footer
.tt-footer {
  margin-top: var(--space-4, 16px);
  text-align: center;
}

.tt-more {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1, 4px);
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: var(--font-size-xs, 0.75rem);
  font-weight: var(--fw-bold, 700);
  color: var(--color-primary, #1a6cf7);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
}
</style>
